<template>
  <div class="agent-profile py-2">
    <div class="text-center py-1" style="color: #388e3c">{{ datetime }}</div>
    <div class="d-flex justify-content-between px-2 py-1">
      <span>Name</span>
      <span>{{ UserInfo.firstName }} {{ UserInfo.lastName }}</span>
    </div>
    <div class="d-flex justify-content-between px-2 py-1">
      <span>Username</span>
      <span>{{ UserInfo.username }}</span>
    </div>
    <div class="d-flex justify-content-between px-2 py-1">
      <span>Balance</span>
      <span>{{ Balance }}</span>
    </div>
    <hr>
    <div class="d-flex justify-content-between px-2 pb-2">
      <router-link :to="{name: 'Profile'}" active-class="font-weight-bold"><i class="far fa-user"></i> ข้อมูลผู้ใช้</router-link>
      <span>|</span>
      <a href="#" @click="logout"><i class="fas fa-sign-out-alt"></i> ออกจากระบบ</a>
    </div>
  </div>
</template>
<script>
import AppConfig from '@/configs/app.config.js'
import Auth from '@/helpers/auth'
import moment from '@/helpers/moment'
import Swal from 'sweetalert2'

export default {
  name: 'MemberProfile',
  data() {
    return {
      datetime: moment().add(543, 'y').format('D MMMM YYYY, HH:mm:ss'),
      TimeInterval: null,
      AccountInterval: null
    }
  },
  computed: {
    UserInfo() {
      return this.$store.state.userProfile
    },
    Balance() {
      return this.$store.state.account.balance.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    Member() {
      return this.$store.state.account.member
    },
    Online() {
      return this.$store.state.account.online
    }
  },
  methods: {
    logout() {
      if(this.$store.state.isProcessTicket) {
        Swal.fire({
          text: 'กรุณาอย่าเปลี่ยนหน้าขณะกำลังส่งโพย',
          icon: 'warning',
          confirmButtonText: 'OK'
        })
      }else{
        Auth.logout()
      }
    }
  },
  mounted() {
    this.$store.dispatch('reloadAccount')

    this.AccountInterval = setInterval(()=>{
      console.log('reload account')
      const isLoggedIn = localStorage.getItem(AppConfig.key.LoggedIn)
      console.log('isLoggedIn', isLoggedIn)
      if(isLoggedIn) {
        this.$store.dispatch('reloadAccount')
      }else{
        clearInterval(this.AccountInterval)
      }
    }, 120000)

    this.TimeInterval = setInterval(()=>{
      this.datetime = moment().add(543, 'y').format('D MMMM YYYY, HH:mm:ss')
    }, 1000)
  },
  beforeDestroy() {
    console.log('beforeDestroy!')
    clearInterval(this.AccountInterval)
    clearInterval(this.TimeInterval)
  }
}
</script>
<style lang="scss" scoped>
.agent-profile {
  font-size: 90%;
  border-bottom: 2px solid #003366;
  color: #003366;
}
</style>
